module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Jd.826562c1.png";